import { createLabeledMessages } from '../../../messageUtils';
const pdf = {
    load: 'Načítanie dokumentu',
    pageLoad: 'Načítanie {{number}} stránky',
    noData: 'PDF dokument nie je vybraný',
    pageNoData: 'Stránka nie je vybraná',
    error: 'Načítanie dokumentu sa nepodarilo',
    pageError: 'Načítanie {{number}} stránky se nepodarilo'
};
export default Object.assign({}, pdf, createLabeledMessages(pdf));
